import { themesConstants } from '@constants/themes';

const initialState = {
    data: {},
    loading: true,
};

export function themes(state = initialState, action) {
    switch (action.type) {
        case themesConstants.THEMES_REQUEST:
            return { ...state, loading: true };
        case themesConstants.THEMES_ALL_SUCCESS:
            return { ...state, data: action.data, loading: false };
        case themesConstants.THEMES_ERROR:
            return { ...state, loading: false };
        default:
            return state;
    }
}
